module.exports = __webpack_public_path__ + "img/DAY5-3.53faf3f8.jpg";